<script>
function tableHeaderColor({ row, column, rowIndex, columnIndex }) {
  if (rowIndex === 0) {
    return 'background-color: #409EFF;color: #fff;font-weight: 500;'
  }
}
export default {
  tableHeaderColor
}
</script>
